import { memo } from 'react';
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { Text } from 'react-internationalization'

const NewVersionModal = memo(props => {
  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">
        <Text id="new_version_title" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Text id="new_version_text" />
        </DialogContentText>
        <br />
        <DialogContentText id="alert-dialog-description">
          <Text id="new_version_text_hint" />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} color="secondary">
          <Text id="cancel" />
        </Button>
        <Button onClick={props.handleReload} color="primary">
          <Text id="reload" />
        </Button>
      </DialogActions>
    </Dialog>
  )
})

export default NewVersionModal
